import { render, staticRenderFns } from "./login_wechat.vue?vue&type=template&id=0c415440&scoped=true&"
import script from "./login_wechat.vue?vue&type=script&lang=js&"
export * from "./login_wechat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c415440",
  null
  
)

export default component.exports